import Logo from "../../assets/logo-with-tagline.png";
import "./index.less";

const  LandingPage = () => {
    return(
        <div className="landing-page-parent-div">
            <img src={Logo} alt="Logo" className="landing-page-logo"/>
            <span className="landing-page-title">LABS STOCK MANAGEMENT</span>
        </div>
    )
}

export default LandingPage;